import { createSelector } from "reselect";

export const selectResultsAggregations = (state) => state.results.aggregations;
export const selectResultsAggregationsPath = (state) => state.results.aggregations.path;
export const selectResultsCount = (state) => state.results.count;
export const selectResultsResult = (state) => state.results.result;
export const selectResultsIsFetching = (state) => state.results.isFetching;
export const selectResultsError = (state) => state.results.error;


/**
 * creates an object for the options of each filter
 * @returns {Object} - an object with options for each filter
 */
export const selectFiltersOptions = createSelector([selectResultsAggregations], (aggregations) => buildFinderFilters(aggregations));

function buildFinderFilters(aggregations) {
  const filters_keys = ['group', 'category', 'lineup', 'series'];
  let filters = {};
  
  filters_keys.forEach(key => {
    filters[key] = [];
    if (Object.prototype.hasOwnProperty.call(aggregations, key)) {
      filters[key] = aggregations[key].map(val => {
        return {'label': val.key, 'value': val.key};
      });
      filters[key].sort((a, b) => {
        return a.value?.localeCompare(b.value)
      });
    }
  });
  
  console.debug("built filters options", filters);
  return filters;
};